module.exports = __webpack_public_path__ + "static/media/ub1.6c647c7a.png";